import React from 'react';
import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const IconArrowRight = ({ stroke='white', className }) => {
    return (
        <svg
            className={className ? className : ''}
            fill='none'
            height={'15px'}
            viewBox='0 0 9 15'
            width={'9px'}
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M1 1L7.5 7.5L1 14'
                stroke='currentcolor'/>
        </svg>

    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    className: PropTypes.string,
    stroke: PropTypes.string,
};

IconArrowRight.propTypes = propTypes;

export default IconArrowRight;
